export default __webpack_public_path__ + "static/media/affiliate-jindokai.0a548be5.png";